import gql from 'graphql-tag'
import dayjs from 'dayjs'

export default ({ object, contractCampaigns, contractFiles }) => {
	return {
		mutation: gql`
			mutation ($object: contracts_insert_input!) {
				insert_contracts_one(object: $object) {
					id
				}
			}
		`,
		variables: {
			object: {
				status: object.status || 'PEN',
				country_id: object.country_id,
				contract_date: dayjs().format('YYYY-MM-DD'),
				name: object.name,
				phone: object.phone,
				cellphone: object.cellphone,
				email: object.email,
				document: object.document,
				user_id: object.user_id,
				signature_nop: object.signature_nop,
				signature_type: object.signature_type,
				contract_type: object.contract_type,
				contract_retention: object.retention_id,
				organization_id: object.organization_id,
				comercial_base: object.comercial_base,
				comercial_category_id: object.comercial_category_id,
				contract_category: object.contract_category,
				delegation: object.delegation_id,
				responsable: object.responsable_id,
				domicilio: object.domicilio,
				poblacion: object.poblacion,
				zipcode: object.zipcode,
				iban: object.iban,
				representant_nif: object.representant_nif,
				representant_type: object.representant_type,
				team: object.team,
				contact_person: object.contact_person,
				contact_admon: object.contact_admon,
				recommended: object.recommended,
				applicant_name: object.applicant_name,
				applicant_email: object.applicant_email,
				comments: object.comments,
				contracts_campaigns: {
					data: contractCampaigns.map(elem => ({
						campaign_id: elem.id
					}))
				},
				contracts_files: {
					data: contractFiles.map(name => ({
						file_url: name
					}))
				}
			}
		}
	}
}
